import React, { useContext } from 'react';
import { ApplicationUIContext, SectionTitle, Form, useDrawerState } from '@yuhuinc/ui-library';
import { Button, Typography } from 'antd';

import RuleDrawer from './RuleDrawer';
import RulesTable from '../Table/RulesTable';
import Spacer from 'components/ui/Spacer';

import { getTranslatedString } from 'helpers/i18n';

const requiredAtLeastOneRule = {
  validator: async (_, rules) => {
    if (!rules || rules.length < 1) {
      return Promise.reject(
        new Error(getTranslatedString('landlordPortal.policies.attributes.rules.errorMessage'))
      );
    }
  },
};

const RulesForm = () => {
  const { isMobile } = useContext(ApplicationUIContext);
  const [, addRuleDrawer] = useDrawerState(false);

  return (
    <>
      <SectionTitle>{getTranslatedString('landlordPortal.policies.attributes.rules')}</SectionTitle>

      <Form.List name="rules" rules={[requiredAtLeastOneRule]} shouldUpdate>
        {(fields, operations, { errors }) => {
          const addRule = (rule) => operations.add(rule);

          return (
            <>
              {fields.length > 0 && <RulesTable rules={fields} operations={operations} />}

              <Spacer mt={1}>
                <Button size={isMobile && 'large'} onClick={addRuleDrawer.open} disabled={false}>
                  {getTranslatedString('landlordPortal.policies.addRule')}
                </Button>
              </Spacer>

              <Form.ErrorList errors={errors} />

              <RuleDrawer mode="create" drawer={addRuleDrawer} addRule={addRule} />
            </>
          );
        }}
      </Form.List>
    </>
  );
};

export default RulesForm;
